import React from 'react'
import { useFirebaseApp, useFirestoreCollection, useFirestoreDoc } from 'reactfire'
import { Link } from 'react-router-dom'
import 'firebase/performance'
import 'firebase/firestore'
import { Box, Header, Heading, Paragraph } from 'grommet'

import Property from '../Property/Property'

function Properties(props) {
  const { userID } = props
  const firebaseApp = useFirebaseApp()
  const userCollectionRef = firebaseApp.firestore().collection(props.userID)
  const userCollection = useFirestoreCollection(userCollectionRef)

  const preferencesRef = firebaseApp
    .firestore()
    .collection(props.userID)
    .doc('preferences')
  const preferencesDoc = useFirestoreDoc(preferencesRef)
  const preferences = preferencesDoc.data()

  // instead of passing preferences we should use something such as Redux.
  const properties = userCollection.docs.map(
    (doc, i) =>
      doc.id !== 'preferences' && (
        <Property docID={doc.id} key={i} preferences={preferences} userID={userID} />
      )
  )
  return properties.length > 0 ? (
    properties
  ) : (
    <Box
      style={{
        display: 'grid',
        alignContent: 'center',
        height: 'calc(100vh - 130px)'
      }}
      pad="medium"
    >
      <Header
        style={{
          justifyContent: 'center'
        }}
      >
        <Heading level={2}>No properties found.</Heading>
      </Header>
      <Paragraph style={{ textAlign: 'center', padding: '20px 30px' }}>
        Sorry, we couldn&apos;t find properties in your catalog, why don&apos;t you <br />
        <Link
          to={{
            pathname: '/add',
            state: {
              userID: props.userID
            }
          }}
          style={{}}
        >
          Add your first property
        </Link>
      </Paragraph>
    </Box>
  )
}

export default Properties
